import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getPageContents } from "../../../actions/admin/cmspage";
import { cn } from "../../../utils/classnames";
import { createTypographyHelper } from "../../../utils/typography";
import { BookSection } from "../../../components/book-section/BookSection";
import { FleetTypeDetail } from "./components/FleetTypeDetail";
import { LazyImage } from "./components/LazyImage";
import WELLCabinGranluxe from "./components/WELLCabinGranluxe";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ToyotaAlphardBanner = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/banner/alphard.jpg";
const ToyotaGranAceBanner = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/toyota-granace-banner.png";
const ToyotaHiaceGrandCabinBanner = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/toyota-hiace-grand-cabin-banner.png";
const ToyotaHiaceLuxuryCabinBanner = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/toyota-hiace-luxury-cabin-banner.png";

const ToyotaAlphardImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/fleet/Alphard/no-bg-new.png";
const ToyotaGranaceImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/fleet/Granace/no-bg-new.png";
const ToyotaHiaceGrandCabin = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/fleet/GrandCabin/no-bg-new.png";
const ToyotaHiaceLuxuryCabin = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/fleet/LuxuryCabin/no-bg-new.png";

const alphard1 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/carousel-image/alphard/01.30-exterior.png";
const alphard2 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/carousel-image/alphard/02.40-exterior.jpg";
const alphard3 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/carousel-image/alphard/03.30-side.png";
const alphard4 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/carousel-image/alphard/04.30-interior-1.png";
const alphard5 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/carousel-image/alphard/05.30-interior-2.png";
const alphard6 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/carousel-image/alphard/06.30-back.png";
const alphard7 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/carousel-image/alphard/07.40-side.jpg";
const alphard8 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/carousel-image/alphard/08.40-interior-1.jpg";
const alphard9 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/carousel-image/alphard/09.40-interior-2.jpg";
const alphard10 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-fleet-types/carousel-image/alphard/10.40-door.jpg";
const granace1 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-1-new.jpeg";
const granace2 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-2-new.jpeg";
const granace3 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-3-new.jpeg";
const granace4 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-4-new.jpeg";
const granace5 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-5-new.jpeg";
const granace6 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-6-new.jpeg";
const granace7 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-7-new.jpeg";
const granace8 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-8-new.jpeg";
const granace9 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-9-new.jpeg";
const granace10 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-10-new.jpeg";
const granace11 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-11-new.jpeg";
const granace12 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace-sm-12-new.jpeg";
const hiace1 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-1-new.jpeg";
const hiace2 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-2-new.jpeg";
const hiace3 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-3-new.jpeg";
const hiace4 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-4-new.jpeg";
const hiace5 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-5-new.jpeg";
const hiace6 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-6-new.jpeg";
const hiace7 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-7-new.jpeg";
const hiace8 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-8-new.jpeg";
const hiace9 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-9-new.jpeg";
const hiace10 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-10-new.jpeg";
const hiace11 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-11-new.jpeg";
const hiace12 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-12-new.jpeg";
const hiace13 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-sm-13-new.jpeg";
const hiace_luxury1 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-luxury-sm-1-new.jpeg";
const hiace_luxury2 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-luxury-sm-2-new.jpeg";
const hiace_luxury3 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-luxury-sm-3-new.jpeg";
const hiace_luxury4 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-luxury-sm-4-new.jpeg";
const hiace_luxury5 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-luxury-sm-5-new.jpeg";
const hiace_luxury6 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-luxury-sm-6-new.jpeg";
const hiace_luxury7 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-luxury-sm-7-new.jpeg";
const hiace_luxury8 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-luxury-sm-8-new.jpeg";
const hiace_luxury9 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace-luxury-sm-9-new.jpeg";
const alphardSeatplan = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/alphard_seatplan.png";
const granaceSeatplan = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/granace_seatmap.png";
const hiaceSeatplan = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace_seatmap.png";
const hiaceLuxurySeatplan = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/hiace_luxury_seatmap.png";

const FleetTypePage = () => {
  const page_name = "cms-index";
  const { location, push } = useHistory();
  const search = new URLSearchParams(location.search);

  const [previewImage, setPreviewImage] = useState(null);

  const tabList = [
    {
      id: "WELLCabinGranLuxe",
    },
    {
      id: "ToyotaAlphard",
      banner: ToyotaAlphardBanner,
      bannerCenter: "90%",
      altBanner: "Toyota Alphard Banner",
      passenger: 6,
      suitcase: 4,
      length: 4930,
      width: 1850,
      height: 1880,
      seatImage: alphardSeatplan,
      video: "https://www.youtube.com/embed/y5mfQMNH-xA?si=HRG_-3q7lqGXs36U",
      carImage: ToyotaAlphardImage,
      // Captions are shown under each gallery image (Toyota Alphard only).
      // Edit the `en` / `jp` text freely — the slider picks the active language.
      images: [
        { src: alphard1, caption: { en: "Toyota Alphard 30 Series", jp: "アルファード 30系" }, onClick: () => setPreviewImage(alphard1) },
        { src: alphard2, caption: { en: "Toyota Alphard 40 Series", jp: "アルファード 40系" }, onClick: () => setPreviewImage(alphard2) },
        { src: alphard3, caption: { en: "Toyota Alphard 30 Series", jp: "アルファード 30系" }, onClick: () => setPreviewImage(alphard3) },
        { src: alphard4, caption: { en: "Toyota Alphard 30 Series", jp: "アルファード 30系" }, onClick: () => setPreviewImage(alphard4) },
        { src: alphard5, caption: { en: "Toyota Alphard 30 Series", jp: "アルファード 30系" }, onClick: () => setPreviewImage(alphard5) },
        { src: alphard6, caption: { en: "Toyota Alphard 30 Series", jp: "アルファード 30系" }, onClick: () => setPreviewImage(alphard6) },
        { src: alphard7, caption: { en: "Toyota Alphard 40 Series", jp: "アルファード 40系" }, onClick: () => setPreviewImage(alphard7) },
        { src: alphard8, caption: { en: "Toyota Alphard 40 Series", jp: "アルファード 40系" }, onClick: () => setPreviewImage(alphard8) },
        { src: alphard9, caption: { en: "Toyota Alphard 40 Series", jp: "アルファード 40系" }, onClick: () => setPreviewImage(alphard9) },
        { src: alphard10, caption: { en: "Toyota Alphard 40 Series", jp: "アルファード 40系" }, onClick: () => setPreviewImage(alphard10) },
      ],
    },
    {
      id: "ToyotaGranAce",
      banner: ToyotaGranAceBanner,
      bannerCenter: "50%",
      altBanner: "Toyota GranAce Banner",
      passenger: 5,
      suitcase: 4,
      length: 5300,
      width: 1970,
      height: 1990,
      seatImage: granaceSeatplan,
      video: "https://www.youtube.com/embed/gKvn9vEx-a4?si=hvsFkqwJo6KyKMQ8",
      carImage: ToyotaGranaceImage,
      images: [
        { src: granace1, onClick: () => setPreviewImage(granace1) },
        { src: granace2, onClick: () => setPreviewImage(granace2) },
        { src: granace3, onClick: () => setPreviewImage(granace3) },
        { src: granace4, onClick: () => setPreviewImage(granace4) },
        { src: granace5, onClick: () => setPreviewImage(granace5) },
        { src: granace6, onClick: () => setPreviewImage(granace6) },
        { src: granace7, onClick: () => setPreviewImage(granace7) },
        { src: granace8, onClick: () => setPreviewImage(granace8) },
        { src: granace9, onClick: () => setPreviewImage(granace9) },
        { src: granace10, onClick: () => setPreviewImage(granace10) },
        { src: granace11, onClick: () => setPreviewImage(granace11) },
        { src: granace12, onClick: () => setPreviewImage(granace12) },
      ],
    },
    {
      id: "ToyotaHiAceGrandCabin",
      banner: ToyotaHiaceGrandCabinBanner,
      bannerCenter: "65%",
      altBanner: "Toyota HiAce Grand Cabin Banner",
      passenger: 9,
      suitcase: 9,
      length: 5380,
      width: 1880,
      height: 2280,
      seatImage: hiaceSeatplan,
      video: "https://www.youtube.com/embed/pkdMR98j8_k?si=4k77qU6Ua-wU0zZy",
      carImage: ToyotaHiaceGrandCabin,
      images: [
        { src: hiace1, onClick: () => setPreviewImage(hiace1) },
        { src: hiace2, onClick: () => setPreviewImage(hiace2) },
        { src: hiace3, onClick: () => setPreviewImage(hiace3) },
        { src: hiace4, onClick: () => setPreviewImage(hiace4) },
        { src: hiace5, onClick: () => setPreviewImage(hiace5) },
        { src: hiace6, onClick: () => setPreviewImage(hiace6) },
        { src: hiace7, onClick: () => setPreviewImage(hiace7) },
        { src: hiace8, onClick: () => setPreviewImage(hiace8) },
        { src: hiace9, onClick: () => setPreviewImage(hiace9) },
        { src: hiace10, onClick: () => setPreviewImage(hiace10) },
        { src: hiace11, onClick: () => setPreviewImage(hiace11) },
        { src: hiace12, onClick: () => setPreviewImage(hiace12) },
        { src: hiace13, onClick: () => setPreviewImage(hiace13) },
      ],
    },
    {
      id: "ToyotaHiAceLuxuryCabin",
      banner: ToyotaHiaceLuxuryCabinBanner,
      bannerCenter: "45%",
      altBanner: "Toyota HiAce Luxury Cabin Banner",
      passenger: 9,
      suitcase: 6,
      length: 5380,
      width: 1880,
      height: 2280,
      seatImage: hiaceLuxurySeatplan,
      video: "https://www.youtube.com/embed/w-IBF0BW2Do?si=SzKEqW7WC3MDX-eS",
      carImage: ToyotaHiaceLuxuryCabin,
      images: [
        { src: hiace_luxury1, onClick: () => setPreviewImage(hiace_luxury1) },
        { src: hiace_luxury2, onClick: () => setPreviewImage(hiace_luxury2) },
        { src: hiace_luxury3, onClick: () => setPreviewImage(hiace_luxury3) },
        { src: hiace_luxury4, onClick: () => setPreviewImage(hiace_luxury4) },
        { src: hiace_luxury5, onClick: () => setPreviewImage(hiace_luxury5) },
        { src: hiace_luxury6, onClick: () => setPreviewImage(hiace_luxury6) },
        { src: hiace_luxury7, onClick: () => setPreviewImage(hiace_luxury7) },
        { src: hiace_luxury8, onClick: () => setPreviewImage(hiace_luxury8) },
        { src: hiace_luxury9, onClick: () => setPreviewImage(hiace_luxury9) },
      ],
    },
  ];

  const [activeTab, setActiveTab] = useState(tabList[0]);

  const cmspage_state = useSelector((state) => state.cmspage);
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);

  useEffect(() => {
    const type = search.get("type");
    const selectedTab = tabList.find((tab) => tab.id === type);
    // A missing or unknown type (e.g. an old link to the retired WELL Cabin
    // page) falls back to the first tab instead of showing a broken page.
    setActiveTab(selectedTab || tabList[0]);
  }, [location.search]);

  return (
    <FrontLayout>
      {activeTab.id === "WELLCabinGranLuxe" ? (
        <WELLCabinGranluxe tabList={tabList} />
      ) : (
      <div className="tw:relative tw:max-w-[1920px] tw:mx-auto tw:font-hanken-grotesk tw:mt-[88px]">
        <div className="tw:max-w-[1920px] tw:m-auto tw:relative">
          <div className="tw:bg-[linear-gradient(87.06deg,#000000_6.43%,rgba(40,42,45,0.3)_46.3%)] tw:w-full tw:h-full tw:absolute tw:top-0 tw:left-0 tw:z-10"></div>
          <LazyImage
            src={activeTab.banner}
            alt={activeTab.altBanner}
            wrapperClassName="tw:w-full"
            className="tw:w-full tw:h-[430px] tw:object-cover"
            loading="lazy"
            style={{
              objectPosition: `center ${activeTab.bannerCenter || "center"}`,
            }}
          />
          <div className="tw:absolute tw:left-5 tw:bottom-8 tw:lg:left-[82px] tw:lg:bottom-[65px] tw:space-y-[14px] tw:z-50">
            <div className="tw:text-[rgba(219,190,120,1)] tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:font-hanken-grotesk tw:leading-none tw:uppercase">
              {t("Fleet.Heading")}
            </div>
            <div className="tw:text-[34px] tw:lg:text-[45px] tw:font-libre-caslon-display tw:leading-[58px] tw:text-white tw:font-normal">
              {t(`FleetTypePage.${activeTab.id}.Title`)}
            </div>
          </div>
        </div>
        <div className="tw:sticky tw:top-[88px] tw:z-40">
          <div className="tw:bg-[#F9F9F9] tw:relative tw:border-b tw:border-b-[#8D8D8D] tw:h-[72px] tw:lg:h-[100px]">
            <div className="tw:flex tw:lg:px-[82px] tw:lg:justify-start tw:px-3 tw:pt-3 tw:lg:pt-[27px] tw:overflow-x-auto tw:whitespace-nowrap tw:absolute tw:w-full">
              {tabList.map((tab) => (
                <div
                  className={cn(
                    "tw:flex-1 tw:lg:flex-0 tw:text-center tw:flex-shrink-0 tw:h-[60px] tw:lg:h-[73px] tw:px-5 tw:lg:px-[26px] tw:flex tw:items-center tw:justify-center tw:font-hanken-grotesk tw:font-normal tw:lg:font-medium tw:space-x-2 tw:lg:space-x-3",
                    getTypographyClass(13),
                    getTypographyClass(14, "lg"),
                    activeTab.id === tab.id
                      ? "tw:bg-white tw:border-x tw:border-x-[#8D8D8D] tw:border-t tw:border-t-[#8D8D8D] tw:text-[#282828] tw:rounded-tl-md tw:rounded-tr-md"
                      : "tw:text-[#8D8D8D] tw:cursor-pointer"
                  )}
                  onClick={() => push(`?type=${tab.id}`)}
                  key={tab.id}
                >
                  <div>{t(`FleetTypePage.${tab.id}.Title`)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="tw:lg:px-[82px]">
          <FleetTypeDetail
            data={activeTab}
            previewImage={previewImage}
            setPreviewImage={setPreviewImage}
          />
        </div>
        <BookSection />
      </div>
      )}
    </FrontLayout>
  );
};
export default FleetTypePage;
